import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export function useLocaleFormatter() {
  const keyPrefix = "Next:Core:LanguageCodes";
  const { t, i18n } = useTranslation("Fixhub", {
    keyPrefix,
  });
  return useCallback(
    (locale: string): string | null => {
      if (!i18n.exists(`${keyPrefix}.${locale}`)) {
        return null;
      }
      return t(locale);
    },
    [t, i18n]
  );
}
